import React, { useEffect , useState } from 'react';
import { fetchMyTravel} from '../../apiCall';
import NotConfirmedYet from '../../containers/notConfirmedYet/notConfirmedYet'
import MySadirTravels from '../../containers/mySadirTravels/mySadirTravels';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';
import { VERSION } from '../../common/version';

function MyInvitation(props) {

    const [userInvitations, setUserInvitations] = useState([]);
    const [error, setError] = useState(false);
    const version = VERSION;


  useEffect(() => {
    getMyTravel();
  }, []);

  const getMyTravel = () => {
     fetchMyTravel(props.location.state.uid, function(response){
        if (!response.result || response == null || response.result == []) {
           setError(true)
          } else {
         setUserInvitations(response.result);
          }
      }).then(()=>{
      }).catch(()=>{
        alert('שגיאה.')
      });
}

  return (
    <div>
      <TopBaner></TopBaner>
      <SideBar></SideBar>
    <h4 className='titles'>הנסיעות שלי</h4>
    <NotConfirmedYet uid={props.location.state.uid} />
    <MySadirTravels uid={props.location.state.uid} />
    {error && (
        <div className='card'>
            <div style={{ 'textAlign': 'center'}}>
                <img className="image" src="logo-pych.png" alt="logo-pych"/>
            </div>
            <h4 className='titles'>אין לך נסיעות קודמות </h4>
        </div>
    )}
    <h4 className='titles'>נסיעות פרטיות</h4>
    {userInvitations && (
        <div className="card-container">
            {userInvitations.map((invitation) => (
                <div className='invitationCard' key={invitation.invNumber}>
                    <div className='direction'>
                     <span className="fieldLabel">מספר הזמנה: </span>
                     <span>{invitation?.invNumber}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> סוג נסיעה:</span>
                     <span>{invitation?.travelType}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel">שם: </span>
                     <span>{invitation?.nameOfCustomer}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel">כמות נסעים: </span>
                     <span>{invitation?.amountOfpeoples}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> תאריך ושעה: </span>
                     <span>{invitation?.dateStartTraveling}, {invitation?.hourStartTraveling}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> טלפון: </span>
                     <span>{invitation?.phone1}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> מסלול: </span>
                     <span>{invitation?.orbit?.orbitDescripionHebrew}</span>
                    </div><div className='direction'>
                     <span className="fieldLabel"> רכב: </span>
                     <span>{invitation?.carType?.carTypeHebrew}</span>
                    </div>
                    <div className='direction'>
                     <span className="fieldLabel"> הערות: </span>
                     <span>{invitation?.notes}</span>
                    </div>
                </div>
            ))}
        </div>
    )}
    <Footer></Footer>
</div>
  );
}

export default MyInvitation;